import { Injectable } from '@angular/core';
import { ToastrService, ToastrConfig } from 'ngx-toastr';

@Injectable(
    { providedIn: 'root' }
)
export class NotificationService {

    
    private readonly bannerTimeout = 10000;
    constructor(private toastr: ToastrService) { }
    showSuccess(message:string,title:string) {
        this.toastr.success(message,title,{timeOut: this.bannerTimeout});
    }
    showInfo(message: string, title: string) {
        this.toastr.info(message, title,{timeOut: this.bannerTimeout});
    }
    showWarning(message: string, title: string) {
        this.toastr.warning(message, title,{timeOut: this.bannerTimeout});
    }
    showError(message: string, title: string) {
        this.toastr.error(message, title, {timeOut: this.bannerTimeout});
    }
    showApiError(
        error: unknown,
        fallbackMessage: string = 'Unable to complete your request. Please try again.',
        title: string = 'Error'
    ): void {
        const body = error && typeof error === 'object' && 'error' in error
            ? error.error
            : undefined;
        const messages: unknown[] = typeof body === 'string'
            ? [body]
            : body && typeof body === 'object'
                ? ['error', 'message', 'detail', 'title'].map(key => (body as Record<string, unknown>)[key])
                : [];
        const message = messages.find((value): value is string =>
            typeof value === 'string' && value.trim().length > 0);

        this.showError(message?.trim() || fallbackMessage, title);
    }
   
}
